import http from '@/biz/http.mjs'

export default {

    delete: ({pkid}) => http.delete('/dmfks/removeDmFks', [pkid]),
}
